import * as Sentry from "@sentry/react";
import { Integrations } from '@sentry/tracing';

const enabledEnvironments = ['development', 'acceptance', 'production']
const developmentSentry = 'https://b4ab566b94f442f2b04e0bbfa13b69b7@o1351458.ingest.sentry.io/6634539'
const sampleRate = process.env.TARGET_ENV === 'production' ? 0.05 : 1;

export default function () {
    if (!enabledEnvironments.includes(process.env.TARGET_ENV)) {
        return;
    }

    const dsn = (process.env.TARGET_ENV !== 'development') ? process.env.SENTRY_DSN : developmentSentry;

    if (dsn) {
        Sentry.init({
            dsn,
            environment: process.env.TARGET_ENV,
            integrations: [new Integrations.BrowserTracing()],
            tracesSampleRate: sampleRate
        });
    }
}
